import { useEffect, useState } from "react";

const navLinks = [
  { href: "#sha", label: "沙雕赛事" },
  { href: "#qi", label: "奇葩盘点" },
  { href: "#min", label: "民间高手" },
  { href: "#mi", label: "迷惑行为" },
  { href: "#tu", label: "土味现场" },
  { href: "#rank", label: "排行榜" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const bg = scrolled
    ? "bg-background-50/90 backdrop-blur border-b border-background-200/80 shadow-sm"
    : "bg-transparent";

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className={`transition-all duration-300 ${bg}`}>
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-trophy-fill text-lg" />
            </span>
            <span className="text-lg font-extrabold tracking-tight text-foreground-900">
              每日<span className="text-primary-600">大赛</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-full px-4 py-2 text-sm text-foreground-700 transition hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden items-center gap-1.5 rounded-full bg-accent-50 px-3 py-1.5 text-xs font-medium text-accent-800 sm:inline-flex">
              <i className="ri-flashlight-fill text-accent-600" />
              每日 20:00 更新
            </span>
            <a
              href="#subscribe"
              className="hidden whitespace-nowrap rounded-full bg-foreground-900 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-foreground-700 md:inline-block"
            >
              订阅每日快乐
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 transition hover:bg-background-200 lg:hidden"
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden">
          <nav className="mx-4 mt-2 rounded-2xl border border-background-200 bg-background-50/95 p-2 shadow-sm backdrop-blur">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 block rounded-xl bg-foreground-900 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅每日快乐
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}